import { IAstNode, ILogicNotAstNode, IComposeFunc } from '../../typings/ast-node';
import { TokenComposeError } from '../../errors';



export function composeLogicNot(astNodes: IAstNode[], compose: IComposeFunc) {
  const i = astNodes.findIndex(({ type, token }) => {
    return type === 'Temporary' && !!token && token.type === 'LogicNot';
  });
  if (i === -1) return;

  const right = astNodes[i + 1];
  const token = astNodes[i].token!;

  if (!right) {
    throw new TokenComposeError('incomplete-expression', '表达式不完整', token.position);
  }

  const rightNode = compose([right]);

  const node: ILogicNotAstNode = {
    type: 'LogicNot',
    right: rightNode,
    token,
    children: [astNodes[i], rightNode]
  };

  astNodes.splice(i, 2, node);

  composeLogicNot(astNodes, compose);
}
